import { EmployeePages } from './EmployeePages';

export default EmployeePages;
